<!-- title和type可以不传，默认是普通数组
data: {
    title: '请你选择',
    type: 0,
    list: ['选项一','选项二']
}

data: {
    title: '请你选择',
    type: 1,
    list: [
        {
            name: 选项一
        },
        {
            name: 选项二
        }
    ]
}-->
<template>
    <section>
        <div class="pop-bg"></div>
        <div class="cont-relat">
            <h3>{{data.title || 'Please select'}}<a @click="closePop"></a></h3>
            <div class="cont-con" v-if="data.type"> <!--对象数组-->
                <p class="tBor" v-for="(item,index) in data.list" :key="index" @click="chooseOpt(item)" v-text="item.term || item.enName"></p>
            </div>
            <div class="cont-con" v-else> <!--普通数组-->
                <p class="tBor" v-for="(item,index) in data.list" :key="index" @click="chooseOpt(item)" v-text="item"></p>
            </div>
        </div>
    </section>
</template>
<script>
export default{
    props: ['data'],
    methods:{
        //选择选项
        chooseOpt(item){
            this.$emit('chooseOpt',item);
            this.closePop();
        },

        //关闭弹窗
        closePop(){
            this.$emit('closePop');
        }
    }
}
</script>

<style scoped>
    @import "../assets/css/onePx.css";
    .pop-bg{ width: 100%; height: 100%; background-color: #000; filter: alpha(opacity=50); opacity: 0.5; position: fixed; top: 0; left: 0; z-index: 10;}
    .cont-relat{ width: 100%; background-color: #FFF; position: fixed; bottom: 0; left: 0; z-index: 11;}
    .cont-relat h3{ line-height: .9rem; color: #999; font-size: .28rem; text-align: center; position: relative;}
    .cont-relat h3 a{ width: .28rem; height: .27rem; background: url("../assets/img/close.png") no-repeat; background-size: cover; position: absolute; top: 0.31rem; right: 0.3rem;}
    .cont-con{ max-height: 6.4rem; overflow: auto;}
    .cont-relat p{line-height: .66rem; padding:0.12rem 0;color: #363636; font-size: .28rem; text-align: center; display: block; position: relative;}
</style>
